module.exports = __webpack_public_path__ + "img/yishengliebiao.539b14c8.png";